import React, { Component } from 'react';

import { IS_VALID } from 'utils';

import Create from './Create';
import View from './View';

export default class FormContainer extends Component {
	render() {
		let {
			loadOptions,
			getRelation,

			actions,

			selectedData,
			formType,

			visibilityOptions,
		} = this.props;

		let createProps = {
			actions,

			loadOptions,
			getRelation,
		};

		let viewProps = {
			selectedData,

			visibilityOptions,

			getRelation,
		};

		switch (formType.toUpperCase()) {
			case 'UPDATE':
			case 'CREATE':
				return <Create {...createProps} />;
				break;
			case 'VIEW':
				return <View {...viewProps} />;
				break;
			case 'DELETE':
				return (
					<p>
						Are you sure you want to delete&nbsp;
						{IS_VALID(selectedData) && IS_VALID(selectedData.get('title')) ? (
							<span style={{ color: 'red' }}>{selectedData.get('title')}</span>
						) : (
							'this data'
						)}
						?
					</p>
				);
				break;
			default:
				return '';
				break;
		}
	}

	componentWillUnmount() {
		let { actions } = this.props;

		actions.setValue({
			selectedData: null,
			formType: '',
			formId: '',
			formTitle: '',

			image: null,
			browser: null,
			url: '',
			sort: '',
			urlType: null,
			promoId: '',
			visibilityType: {
				label: 'Always On',
				value: 'AO',
			},
			visibilityStartTime: '',
			visibilityEndTime: '',
			campaignStartDate: '',
			campaignEndDate: '',

			cardType: [],
			specificUser: [],
			blacklistedUser: [],
			deviceType: {
				label: 'All',
				value: 'ALL',
			},
			isUploadingCSVFile: false,
			isUploadingCSVFileBlacklistedUser: false,
		});
	}
}



// WEBPACK FOOTER //
// ./components/MkioskBanner/FormContainer/index.js